<template>
  <div class="flex items-center justify-between">
    <div class="flex flex-col space-y-2">
      <lf-heading2 class="mb-0">{{ title }}</lf-heading2>
      <span v-if="description">{{ description }}</span>
    </div>
    <slot name="action" />
  </div>
</template>

<script setup lang="ts">
import LfHeading2 from "@/components/ui/text/LfHeading2.vue";

defineProps({
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
  },
});
</script>
